// extracted by mini-css-extract-plugin
export default {"defaultPage":"DefaultPageLayout_defaultPage__8y4lw"};